const ACTION_TTL_MS = 5000;
const pending = new Map();

const normalize = (query) => String(query ?? "").trim().toLowerCase().replace(/\s+/g, " ");

const randomId = () => {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID().replace(/-/g, "");
  }
  const bytes = new Uint8Array(24);
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
};

export function searchActionHeaders(query, scope) {
  const normalizedQuery = normalize(query);
  const now = Date.now();
  let action = pending.get(normalizedQuery);

  if (!action || action.expiresAt <= now || action.scopes.has(scope)) {
    action = { id: randomId(), expiresAt: now + ACTION_TTL_MS, scopes: new Set() };
    pending.set(normalizedQuery, action);
  }

  action.scopes.add(scope);
  for (const [key, value] of pending) {
    if (value.expiresAt <= now) pending.delete(key);
  }

  return {
    "X-Paralegal-Search-Action-Id": action.id,
    "X-Paralegal-Search-Query": String(query ?? "").slice(0, 500),
  };
}
